import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Vendorview.css";
import Navbar from "../components/navbar";
import { toast } from "react-toastify";

const Vendorview = () => {
  const [vendorData, setVendorData] = useState({
    businessName: "",
    address: "",
    city:"",
    state:"",
    pincode: "",
    sinceFrom: "",
    specialistIn: "",
    contactPerson: "",
    contactNumber: "",
    pesticideLicence: "",
    gstNumber: "",
    membership: "",
    branchDetails: "",
    technicalQualification: "",
    aboutUs: "",
  });
const specialistOptions = [
  "Termite Control",
  "Preconstruction Anti-Termite Treatment",
  "General Pest Control",
  "Cockroach Gel Treatment",
  "Cockroach Control",
  "Mosquito Control",
  "Ants Control",
  "Wood Borer Treatment",
  "Rat Control",
  "Bird Control",
  "Spider Control",
  "Lizard control",
  "Dog ticks Control Treatment",
  "Bed bug treatment",
];
 const membershipOption= [
     "IPCA",
     "PCAI",
     "PMA",
     "KPMA","TNPMA"
 ]
 const states = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttarakhand",
    "Uttar Pradesh",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Lakshadweep",
    "Puducherry"
]
  const [propertyImages, setPropertyImages] = useState([]);
  const [existingPropertyImages, setExistingPropertyImages] = useState([]);
  const [logoImage, setLogoImage] = useState(null);
  const [existingLogoImage, setExistingLogoImage] = useState(null);
  const [error, setError] = useState(null);
  const [isEditable, setIsEditable] = useState(false);

  const vendorId = window.localStorage.getItem("vendorId");

  useEffect(() => {
    if (!vendorId) {
      setError("No vendor ID found");
      return;
    }

    axios
      .post(`${process.env.REACT_APP_API_URL}/getvendorDetails`, { vendorId })
      .then((response) => {
        if (response.data.status === "ok") {
          const data = response.data.data;
          setVendorData(data);
          if (data.logo) setExistingLogoImage(data.logo);
          if (data.image) setExistingPropertyImages(data.image);
        } else {
          setError(response.data.message);
        }
      })
      .catch((error) => {
        setError(error.message);
      });
  }, [vendorId]);

  const handleChange = (field, value) => {
    setVendorData({ ...vendorData, [field]: value });
  };

  const handleLogoImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const preview = URL.createObjectURL(file);
      setLogoImage({ file, preview });
      setExistingLogoImage(null);
    }
  };

 const handleGalleryImageChange = (e) => {
  const files = Array.from(e.target.files);
  const totalImages = existingPropertyImages.length + propertyImages.length;

  if (totalImages + files.length > 5) {
    toast.error('Only 5 images allowed. Remove one to add a new image.');
    return;
  }

  const previews = files.map((file) => ({
    file,
    preview: URL.createObjectURL(file),
  }));

  setPropertyImages((prev) => [...prev, ...previews]);
};


const handleRemoveGalleryImage = (index, isExisting = false) => {
  if (isExisting) {
    const updatedExisting = [...existingPropertyImages];
    updatedExisting.splice(index, 1);
    setExistingPropertyImages(updatedExisting);
  } else {
    const updatedNew = [...propertyImages];
    URL.revokeObjectURL(updatedNew[index].preview);
    updatedNew.splice(index, 1);
    setPropertyImages(updatedNew);
  }
};

  const handleSave = () => {
    const formData = new FormData();
    formData.append("vendorId", vendorId);

    Object.entries(vendorData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((val) => formData.append(`${key}[]`, val));
      } else {
        formData.append(key, value);
      }
    });

    if (logoImage) {
      formData.append("logoImage", logoImage.file);
    }

    propertyImages.forEach((imgObj) => {
      formData.append("propertyImages", imgObj.file);
    });

    axios
      .post(`${process.env.REACT_APP_API_URL}/updateVendorAllDetails/${vendorId}`, formData)
      .then((response) => {
        if (response.data.status === "ok") {
          toast.success("Data updated successfully!");
          setIsEditable(false);
        } else {
          setError(response.data.message);
        }
      })
      .catch((error) => {
        setError(error.message);
        toast.error("Error updating data");
      });
  };

  const renderField = (label, field, disableEdit = false) => (
    <>
      <div className="vendor-label">{label}</div>
      <div className="vendor-value">
        {isEditable && !disableEdit ? (
          <input
            type="text"
            className="form-control"
            value={
              Array.isArray(vendorData[field])
                ? vendorData[field].join(", ")
                : vendorData[field]
            }
            onChange={(e) =>
              handleChange(
                field,
                field === "specialistIn"
                  ? e.target.value.split(",").map((s) => s.trim())
                  : e.target.value
              )
            }
          />
        ) : Array.isArray(vendorData[field])
          ? vendorData[field].join(", ")
          : vendorData[field] || "-"}
      </div>
    </>
  );

  return (
    <>
      <Navbar />
      <div className="bodyvendorresult">
        <div className="pt-3">
          <div className="container containerDashboard">
            <div className="mb-4 p-3 d-flex justify-content-between">
              <h2>Your Details</h2>
              <button
                className="btn btn-primary mb-4"
                onClick={() => {
                  if (isEditable) handleSave();
                  else setIsEditable(true);
                }}
              >
                {isEditable ? "Save" : "Edit"}
              </button>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className="vendor-details">
              {renderField("Company Name", "businessName", true)}
              {renderField("Contact Person", "contactPerson")}
              {renderField("Contact Number", "contactNumber", true)}
              {renderField("Address", "address")}
             <div className="vendor-label">State</div>
<div className="vendor-value">
  {isEditable ? (
    <select
      className="form-select"
      value={vendorData.state}
      onChange={(e) => handleChange("state", e.target.value)}
    >
      <option value="">Select State</option>
      {states.map((state, idx) => (
        <option key={idx} value={state}>
          {state}
        </option>
      ))}
    </select>
  ) : (
    vendorData.state || "-"
  )}
</div>

                {renderField("City", "city")}
              {renderField("Pincode", "pincode", true)}
              {renderField("Since From", "sinceFrom")}
              <div className="vendor-label">Specialist In</div>
<div className="vendor-value">
  {isEditable ? (
    <div className="row">
      {specialistOptions.map((option, idx) => (
        <div className="col-md-4" key={idx}>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id={`specialist-${idx}`}
              checked={vendorData.specialistIn.includes(option)}
              onChange={(e) => {
                const updated = e.target.checked
                  ? [...vendorData.specialistIn, option]
                  : vendorData.specialistIn.filter((item) => item !== option);
                handleChange("specialistIn", updated);
              }}
            />
            <label className="form-check-label" htmlFor={`specialist-${idx}`}>
              {option}
            </label>
          </div>
        </div>
      ))}
    </div>
  ) : (
    vendorData.specialistIn?.length
      ? vendorData.specialistIn.join(", ")
      : "-"
  )}
</div>

              {renderField("Pesticide Licence", "pesticideLicence", true)}
              {renderField("GST Number", "gstNumber", true)}
            
                 <div className="vendor-label">Membership</div>
<div className="vendor-value">
  {isEditable ? (
    <div className="row">
      {membershipOption.map((option, idx) => (
        <div className="col-md-4" key={idx}>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id={`membership-${idx}`}
              checked={vendorData.membership.includes(option)}
              onChange={(e) => {
                const updated = e.target.checked
                  ? [...vendorData.membership, option]
                  : vendorData.membership.filter((item) => item !== option);
                handleChange("membership", updated);
              }}
            />
            <label className="form-check-label" htmlFor={`specialist-${idx}`}>
              {option}
            </label>
          </div>
        </div>
      ))}
    </div>
  ) : (
    vendorData.membership?.length
      ? vendorData.membership.join(", ")
      : "-"
  )}
</div>
              {renderField("Branch Details", "branchDetails")}
              {renderField("Technical Qualification", "technicalQualification")}

              <div className="vendor-label">About Us</div>
              <div className="vendor-value">
                {isEditable ? (
                  <textarea
                    className="form-control"
                    value={vendorData.aboutUs}
                    onChange={(e) => handleChange("aboutUs", e.target.value)}
                    rows="4"
                  />
                ) : (
                  vendorData.aboutUs || "-"
                )}
              </div>
            </div>

            <hr className="my-5" />

            <>
              <h4>Upload Logo</h4>
              <div className="upload-logo">
                {isEditable && (
                  <label className="upload-box">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleLogoImageChange}
                      hidden
                      name="logoImage"
                    />
                    <div className="upload-content text-center">
                      <span className="display-5">+</span>
                      <p>Upload Logo</p>
                    </div>
                  </label>
                )}
                {logoImage ? (
                  <div className="image-thumbnail">
                    <img src={logoImage.preview} alt="Uploaded Logo" />
                    <button
                      type="button"
                      className="remove-btn btn-close"
                      onClick={() => setLogoImage(null)}
                    ></button>
                  </div>
                ) : (
                  existingLogoImage && (
                    <div className="image-thumbnail">
                      <img
                        src={`${process.env.REACT_APP_API_URL}/uploads/${existingLogoImage}`}
                        style={{ width: "100px" }}
                        alt="Existing Logo"
                      />
                    </div>
                  )
                )}
              </div>

              <hr className="my-5" />

              <h4>Upload Property Photos</h4>
            <div className="gallery-grid mt-3">
  {isEditable && (existingPropertyImages.length + propertyImages.length < 5) && (
    <label className="upload-box">
      <input
        type="file"
        accept="image/*"
        multiple
        onChange={handleGalleryImageChange}
        hidden
        name="propertyImages"
      />
      <div className="upload-content text-center">
        <span className="display-5">+</span>
        <p>Upload Photos</p>
      </div>
    </label>
  )}

  {/* Existing images */}
  {existingPropertyImages.map((url, index) => (
    <div className="image-thumbnail" key={`existing-${index}`}>
      <img
        src={`${process.env.REACT_APP_API_URL}/uploads/${url}`}
        alt={`existing-${index}`}
      />
      {isEditable && (
        <button
          type="button"
          className="remove-btn btn-close"
          onClick={() => handleRemoveGalleryImage(index, true)}
        ></button>
      )}
    </div>
  ))}

  {/* Newly uploaded images */}
  {propertyImages.map((imgObj, index) => (
    <div className="image-thumbnail" key={`new-${index}`}>
      <img src={imgObj.preview} alt={`uploaded-${index}`} />
      <button
        type="button"
        className="remove-btn btn-close"
        onClick={() => handleRemoveGalleryImage(index)}
      ></button>
    </div>
  ))}
</div>


            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vendorview;
